import { motion } from "framer-motion";
import React from "react";
import founderImg from "../../src/assets/ryhan.jpg";
import logo from "../assets/smartstart-logo-side-text-3.png";
import { CustomButton } from "./sections/Buttons";
import { Link } from "react-router-dom";


const leftAnim = {
  initial: { opacity: 0, x: -60 },
  whileInView: { opacity: 1, x: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.8, ease: "easeInOut" },
};
const rightAnim = {
  initial: { opacity: 0, x: 60 },
  whileInView: { opacity: 1, x: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.8, ease: "easeInOut" },
};

const AboutPage = () => (
  <div className="bg-white">
    {/* Hero Section */}
    <motion.section
      {...leftAnim}
      className="bg-purple-700 text-white py-16 text-center"
    >
      <img src={logo} alt="SmartStart Logo" className="mx-auto mb-4 w-24" />
      <h1 className="text-5xl font-extrabold mb-4">About Us</h1>
      <p className="max-w-xl mx-auto text-base font-medium p-4 text-justify lg:text-center">
        Welcome to Spectrum Nurturing Academy. We offer a full range of services to meet your
        child's needs, including Speech, Occupational & Developmental Behavior
        Therapy.
      </p>
    </motion.section>





    {/* Welcome & Story */}
    <motion.section {...rightAnim} className="max-w-3xl mx-auto py-12 px-4">
      <h2 className="text-3xl font-extrabold text-center mb-6">Welcome</h2>
      <p className=" mb-2 text-gray-700 pl-4 pr-4">
        Spectrum Nurturing Academy Believes that all children have the right to develop, to be
        fully known hearts and minds, and to be understood deeply.
      </p>
      <p className=" mb-12 text-gray-700 pl-4 pr-4 text-justify ">
        If you are searching for a cutting-edge educational program for your
        typically developing child, or if your child has special abilities, our
        Relationship based Developmental Educational Model is a dynamic,
        educational and above all, a fun way for children to learn and grow. At
        Spectrum Nurturing Academy Developmental Learning Center children, parents and educators
        journey together!
      </p>
      <h2 className="text-3xl font-extrabold text-center mb-6">Our Story</h2>
      <p className=" text-gray-700 mb-2 pl-4 pr-4 text-justify ">
        Spectrum Nurturing Academy (SNA) was founded by a team of passionate Special Educators and Autism Behavior Therapists who saw a need for a nurturing, inclusive space where children with autism could thrive.
      </p>
      <p className=" text-gray-700 mb-2 pl-4 pr-4 text-justify">
        Driven by compassion and guided by experience, we created a center that blends therapy, education, and values-based learning—tailored to each child’s unique needs. From speech and behavior support to life skills and social-emotional growth, every program at SNA is designed to help children succeed in school and life.
      </p>
      <p className=" text-gray-700 pl-2 pr-4 text-justify ">
       At SNA, we don’t just provide support—we believe in every child’s potential.
      </p>
    </motion.section>

    {/* Founder Section */}
    <motion.section
      {...leftAnim}
      className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-8 py-12 px-4"
    >
      <div className="flex-1">
        <h3 className="text-xl font-bold mb-2 p-4">
          Director & Founder | Behavior Therapist
        </h3>
        <p className="text-gray-700 mb-0 text-justify p-4 pb-0 ">


Rayhan Khan is the Director and Founder of Spectrum Nurturing Academy, a pioneering platform dedicated to providing specialized educational and therapeutic services for children with autism and other developmental disabilities. With over a decade of experience as a behavior therapist and special education professional, Rayhan is passionate about creating inclusive, nurturing environments that promote growth, learning, and independence for children with special needs.</p> <p className="text-gray-700 mb-0 text-justify p-4 pb-0 ">

As a skilled Behavior Therapist, Rayhan utilizes evidence-based Applied Behavior Analysis (ABA) techniques to support children in both home and school settings. He collaborates closely with families, educators, and healthcare professionals to develop individualized interventions that foster meaningful progress.</p> <p className="text-gray-700 mb-0 text-justify p-4 pb-0 ">

Under Rayhan’s leadership, Spectrum Nurturing Academy has developed innovative tools, including an AAC communication app tailored for non-verbal children in Bengali and English, as well as a handwriting error detection app designed to assist students with disabilities. Rayhan also authors educational resources, including What Autism Can Do?—a collection of inspiring stories highlighting the strengths of children on the autism spectrum.</p> <p className="text-gray-700 mb-0 text-justify p-4 pb-0 ">

Rayhan holds a Master of Arts in Special Education with a focus on Autism Spectrum Disorders from California State University, Los Angeles, where he continues his academic and research pursuits to better understand language development in children with autism.
</p>
  
      </div>
      <div className="flex-shrink-0">
        <img
          src={founderImg}
          alt="Founder Rayhan Khan"
          className="rounded-t-full rounded-b-full md:w-72 lg:max-w-96 object-cover border-4 border-white shadow-lg"
        />
      </div>
    </motion.section>

    {/* Staff Cards */}
    <motion.section
      {...rightAnim}
      className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 py-12 px-4"
    >
      <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center">
        <div className="bg-orange-100 rounded-full p-4 mb-4">
          <svg
            className="w-8 h-8 text-orange-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 14l9-5-9-5-9 5 9 5z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 14l6.16-3.422A12.083 12.083 0 0112 21.5a12.083 12.083 0 01-6.16-10.922L12 14z"
            />
          </svg>
        </div>
        <h4 className="font-bold text-lg mb-2">Teachers</h4>
        <p className="text-gray-600 text-sm text-justify">
          Spectrum Nurturing Academy employs both early childhood special education and general
          education teachers. Each must complete an advanced degree in their
          area of specialization, our special education teachers are
          credentialed and all teachers must have a minimum of three years
          experience working with children. Not only have most of our teaching
          staff exceeded these requirements-they also participate in an
          extensive Developmental Sensory Relationship-based Model and
          DIR/Floortime Model training.
        </p>
      </div>
      <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center">
        <div className="bg-orange-100 rounded-full p-4 mb-4">
          <svg
            className="w-8 h-8 text-orange-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6 3.87v-2a4 4 0 00-3-3.87m6 3.87v-2a4 4 0 00-3-3.87"
            />
          </svg>
        </div>
        <h4 className="font-bold text-lg mb-2">Teachers' assistants</h4>
        <p className="text-gray-600 text-sm text-justify">
          At Spectrum Nurturing Academy our teaching assistants are full members of our teaching
          team and many hold bachelors degrees in special education or a related
          field.
        </p>
      </div>
      <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center">
        <div className="bg-orange-100 rounded-full p-4 mb-4">
          <svg
            className="w-8 h-8 text-orange-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm0 0V4m0 7v7"
            />
          </svg>
        </div>
        <h4 className="font-bold text-lg mb-2">Therapists</h4>
        <p className="text-gray-600 text-sm text-justify">
          Spectrum Nurturing Academy's speech pathologists and occupational therapists are fully
          licensed and have expertise in sensory integration. Our Developmental
          Interventionists must have a minimum of a BA in child development or a
          related field.
        </p>
      </div>
    </motion.section>

    {/* Come Visit Us CTA */}
    <div className="flex justify-center items-center">
      <motion.section
      {...leftAnim}
      className="max-w-5xl bg-gradient-to-r from-orange-400 to-yellow-300 py-16 rounded-3xl mx-2 md:mx-8 my-12 text-center shadow-lg"
    >
      <h2 className="text-3xl font-extrabold text-white ">Come Visit Us</h2>
      <p className="text-white mb-6 p-14">
        Contact us today to schedule a free evaluation and tour. Our dedicated
        team <br /> is ready to help your child succeed.
      </p>
    
       <div className="flex justify-center mt-6">
          <Link to="/contact">
          <CustomButton
            label="CONTACT US"
            colorClass="text-white bg-black hover:bg-black-500"
          />
        </Link>
        </div>
    </motion.section>
    </div>
  </div>
);

export default AboutPage;
